import { render, staticRenderFns } from "./VoiceItem1.vue?vue&type=template&id=c5db751e&scoped=true"
import script from "./VoiceItem1.vue?vue&type=script&lang=js"
export * from "./VoiceItem1.vue?vue&type=script&lang=js"
import style0 from "./VoiceItem1.vue?vue&type=style&index=0&id=c5db751e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5db751e",
  null
  
)

export default component.exports